import v1 from './v1.vue';


export default {
  v1
}
